import { useTranslation } from 'react-i18next'

import { ArrowsLeftRightIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import Statistic from '@/common/components/Statistic/Statistic'
import { viewIds } from '@/returns/pages/TransactionsPage/constants'

const CurrentMonthExchanges = ({ exchanges, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      Icon={ArrowsLeftRightIcon}
      label={t('Cambios')}
      value={<AnimatedNumber target={exchanges} format="decimal" />}
      onClick={() => onClick(viewIds.lastThirtyDaysExchanges)}
    />
  )
}

export default CurrentMonthExchanges
